import type { FC } from 'react';

import NotEnoughRuby from '@wwe-portal/ui/assets/images/common/not-enough-ruby.webp';

export const NotEnoughRubyIcon: FC<{
  size?: number;
  className?: string;
}> = ({ className, size }) => {
  return (
    <img
      alt="Not Enough Ruby"
      height={size}
      src={NotEnoughRuby}
      width={size}
      className={className}
    />
  );
};
